import { NavItem } from './general.known.routes';

/**
 * DON'T EVER CHANGE NUMERATION
 */
export enum HospitalsKnownItemId {
  HOSPITALS = 1,
  MANAGE_PATIENTS = 2,
  MANAGE_HOSPITALS = 3,
  REPORT_INDICATORS = 4,
  REPORT_NOVELTIES = 5,
  IPS_DIRECTORY = 6,
  UPDATE_INFORMATION = 7,
}

const simpleTransformer = (input: NavItem): NavItem & { type: 'hospital' } => {
  return {
    ...input,
    type: 'hospital',
  };
};

export const HospitalsKnownRoutes = (k: HospitalsKnownItemId): NavItem => {
  return JSON.parse(JSON.stringify(options[k]));
};
const options: {
  [k in HospitalsKnownItemId]: NavItem & { type: 'hospital' };
} = {
  [HospitalsKnownItemId.HOSPITALS]: simpleTransformer({
    id: HospitalsKnownItemId.HOSPITALS,
    route: '/home/hospitals',
    iconName: 'hospital',
    displayName: 'Hospitales',
  }),
  [HospitalsKnownItemId.MANAGE_PATIENTS]: simpleTransformer({
    id: HospitalsKnownItemId.MANAGE_PATIENTS,
    route: '/home/hospitals/managePatient',
    iconName: 'personal-injury',
    displayName: 'Gestionar Pacientes',
    parentModule: 'hospitals',
  }),
  [HospitalsKnownItemId.MANAGE_HOSPITALS]: simpleTransformer({
    id: HospitalsKnownItemId.MANAGE_HOSPITALS,
    route: '/home/hospitals/manageHospitals',
    iconName: 'corporate_fare',
    displayName: 'Gestionar Hospitales',
    parentModule: 'hospitals',
  }),
  [HospitalsKnownItemId.REPORT_INDICATORS]: simpleTransformer({
    id: HospitalsKnownItemId.REPORT_INDICATORS,
    route: '/home/hospitals/reportIndicators',
    iconName: 'indicators',
    displayName: 'Reportar Indicadores',
    parentModule: 'hospitals',
  }),
  [HospitalsKnownItemId.REPORT_NOVELTIES]: simpleTransformer({
    id: HospitalsKnownItemId.REPORT_NOVELTIES,
    route: '/home/hospitals/reportNovelty',
    iconName: 'news-small',
    displayName: 'Reportar Novedades',
    parentModule: 'hospitals',
  }),
  [HospitalsKnownItemId.IPS_DIRECTORY]: simpleTransformer({
    id: HospitalsKnownItemId.IPS_DIRECTORY,
    route: '/home/hospitals/ips-directory',
    iconName: 'news',
    displayName: 'Directorio de IPS',
    parentModule: 'hospitals',
  }),
  [HospitalsKnownItemId.UPDATE_INFORMATION]: simpleTransformer({
    id: HospitalsKnownItemId.UPDATE_INFORMATION,
    route: '/home/hospitals/updateInformation',
    iconName: 'update',
    displayName: 'Actualizar Información',
    parentModule: 'hospitals',
  }),
};
